/**
 * Expande ítems DTE NP (`_is_warehouse_guide_lines_send`) al payload de líneas.
 */
export function buildGuideLinesFromFormItems(items) {
	const guideDetails = [];
	for (const item of items || []) {
		const mv = item?._module_vars || {};
		if (!mv._is_warehouse_guide_lines_send) continue;

		const ids = mv.guide_detail_ids || [];
		const kgs = mv.individual_kilograms || [];
		if (!ids.length) continue;

		ids.forEach((id, index) => {
			const kg = Number(kgs[index]);
			if (!Number.isFinite(kg) || kg <= 0) return;
			guideDetails.push({
				id: String(id),
				kilograms_to_send: kg,
			});
		});
	}
	return guideDetails;
}
